export const educationData = [
    {
        id: 1,
        institution: 'Munshirhat High School',
        course: 'Secondary School Certificate', 
        startYear: '',
        endYear: 'Completed-2015'
    },
    {
        id: 2,
        institution: 'Chandpur Government College',
        course: 'Higher Secondary Education',
        startYear: '',
        endYear: 'Completed-2017'
    },
    {
        id: 3,
        institution: 'National University, Bangladesh',
        course: 'Bachelor of Science',
        startYear: '2019',
        endYear: 'Not Complete-2019'
    },
]